import { useEffect } from 'react'

export default function BaseModal({
  isOpen,
  onClose,
  title,
  subtitle,
  widthClassName = 'max-w-lg',
  footer,
  children,
}) {
  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose?.()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = prevOverflow
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/40 p-4 backdrop-blur-[2px] animate-in fade-in duration-200"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.()
      }}
    >
      <div
        className={`w-full ${widthClassName} flex max-h-[90vh] flex-col rounded-2xl border border-outline-variant/30 bg-surface-container-lowest shadow-2xl backdrop-blur-xl animate-in zoom-in-95 duration-200`}
      >
        {/* Header */}
        <div className="flex items-start justify-between border-b border-outline-variant/15 p-6">
          <div>
            <h3 className="text-xl font-extrabold tracking-tight text-on-surface">
              {title}
            </h3>
            {subtitle && (
              <p className="mt-1 text-xs text-on-surface-variant font-medium">
                {subtitle}
              </p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1 text-on-surface-variant/60 transition-colors hover:bg-surface-container-high hover:text-on-surface cursor-pointer"
            aria-label="Close"
          >
            <span className="material-symbols-outlined text-xl">close</span>
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6">{children}</div>

        {/* Footer */}
        {footer && (
          <div className="flex items-center justify-end gap-3 border-t border-outline-variant/15 bg-surface-container-low/30 px-6 py-4">
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}
